module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Senior-04Merit_Prize_S03.f8cf08e0.png";